import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Tag calls that check auth status silently so 401s don't produce error toasts.
export const AUTH_CHECK_URLS = new Set(["/auth/me"]);

// Global 401 handler wired up in <AuthProvider>. Kept as a mutable ref so we
// can update it without recreating the axios instance.
export const authHandlers = {
  onUnauthorized: null, // (opts: { silent: boolean, from: string }) => void
};

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && authHandlers.onUnauthorized) {
      const silent = AUTH_CHECK_URLS.has(url);
      authHandlers.onUnauthorized({ silent, from: url });
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
